import { connect } from 'react-redux'
import AssetLibrary from '../components/AssetLibrary'
import * as api from '../store/api'

const mapStateToProps = (state) => {
    return {
        user: state.service.user
    };
}

const mapDispatchToProps = (dispatch) => ({
    checkUserSession: (callback) => { dispatch(api.checkUserSession()).then(callback) },
    listAssets: (assetType, callback) => {
        dispatch(api.listAssets(assetType)).then(callback)
    },
    uploadAsset: (data, callback) => {
        dispatch(api.uploadAsset(data)).then(callback)
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(AssetLibrary)
